type QueryMarkContext = {
  content: string
  queryTermsRegExp: string
}

type ResolveContext = {
  omniUrl?: string
  url?: string
  omniTitle?: string
  title?: string
  omniDescription?: string
  description?: string
  category?: string
}

type SearchHelpers = {
  queryMark: (context: QueryMarkContext) => string
  resolveStringItems: (itemsArray: unknown[]) => string
  resolvedUrl: (context: ResolveContext) => string
  resolvedTitle: (context: ResolveContext) => string
  resolvedDescription: (context: ResolveContext) => string
  resolvedCategory: (context: ResolveContext) => string
}

export const searchUtils = {
  helpers: {} as SearchHelpers,
  filters: {} as Record<string, (input: string) => string>
}

// Highlight query terms in content
searchUtils.helpers.queryMark = function (context: QueryMarkContext): string {
  let content = context.content

  if (content) {
    content = content.replace(/\n/g, '')
    const queryTerms = context.queryTermsRegExp
    if (queryTerms) {
      const TERMS = new RegExp(`(\\b[^\\s]*?${queryTerms}[^\\s]*?\\b)`, 'gi')
      content = content.replace(TERMS, '<mark>$&</mark>')
    }
  } else {
    content = ''
  }

  return content
}

// Phone number formatting
searchUtils.filters.ph = function (phoneNo: string): string {
  return phoneNo.trim().replace(/\s+?/g, '-')
}

// Name segment formatting
searchUtils.filters.nseg = function (name: string): string {
  return name.toLowerCase().replace(/\s+?/g, '.') + '/'
}

// Query string formatting
searchUtils.filters.qs = function (query: string): string {
  return query.replace(/\s+/g, '+')
}

// Decode &amp;amp; to &amp;
searchUtils.filters.ramps = function (str: string): string {
  return str.replace(/&amp;amp;/g, '&amp;')
}

// Return first valid string item
searchUtils.helpers.resolveStringItems = function (
  itemsArray: unknown[]
): string {
  for (const element of itemsArray) {
    const item = element
    if (typeof item === 'string' && item.length > 0) {
      return item
    }
  }
  return ''
}

// Resolve URL from context
searchUtils.helpers.resolvedUrl = function (context: ResolveContext): string {
  const items = [context.omniUrl || '', context.url || '']
  return searchUtils.helpers.resolveStringItems(items)
}

// Resolve title from context
searchUtils.helpers.resolvedTitle = function (context: ResolveContext): string {
  const items = [context.omniTitle || '', context.title || '']
  return searchUtils.helpers.resolveStringItems(items)
}

// Resolve description from context
searchUtils.helpers.resolvedDescription = function (
  context: ResolveContext
): string {
  const items = [context.omniDescription || '', context.description || '']
  let resolvedDescription = ''

  try {
    resolvedDescription =
      searchUtils.helpers.resolveStringItems(items).replace(/null/gi, '') || ''
    if (resolvedDescription) {
      resolvedDescription = /(^skip to main|\\u000)/i.test(resolvedDescription)
        ? ' '
        : resolvedDescription
    }
  } catch (e) {
    resolvedDescription = ''
  }

  return resolvedDescription
}

// Resolve category with filters
searchUtils.helpers.resolvedCategory = function (
  context: ResolveContext
): string {
  const VALTEST = /(null|,)/i
  const category = context.category

  if (typeof category !== 'string') return ''
  if (category.length > 40) return ''
  if (VALTEST.test(category)) return ''

  return category
}

// URI decoding
searchUtils.filters.duc = function (str: string): string {
  return decodeURIComponent(str)
}

// URI encoding
searchUtils.filters.enc = function (str: string): string {
  return encodeURIComponent(str)
}
